import axios from "axios";
import axiosInstance from "@/lib/axios";
import type { ApiSuccessResponse, GetGenreParams } from "@/types/tag";

import { SERVICE_UNAVAILABLE_ERROR, ApiErrorResponse } from "@/types/apierror";

const TAGS_URL = "/tags/by-name";
export const getContentByGenre = async (
  params: GetGenreParams,
): Promise<ApiSuccessResponse | ApiErrorResponse> => {
  try {
    const { data } = await axiosInstance.get(`${TAGS_URL}/${params.genre}`, {
      params,
      withCredentials: true,
    });

    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      if (!err.response) {
        return SERVICE_UNAVAILABLE_ERROR;
      }

      return err.response.data as ApiErrorResponse;
    }

    return SERVICE_UNAVAILABLE_ERROR;
  }
};
